/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Staff_Nav_HomeInputs */

const id_staff_nav_home = /** @type {(inputs: Staff_Nav_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beranda`)
};

const en_staff_nav_home = /** @type {(inputs: Staff_Nav_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Home`)
};

/**
* | output |
* | --- |
* | "Home" |
*
* @param {Staff_Nav_HomeInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const staff_nav_home = /** @type {((inputs?: Staff_Nav_HomeInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Staff_Nav_HomeInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_staff_nav_home(inputs)
	return id_staff_nav_home(inputs)
});